import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { ICON } from 'resources/constants';

import { useText } from 'common/hooks';

import {
  Modal,
  CloseIconContainer,
  CloseIcon,
  InnerWrapper,
  StreakCircle,
  Title,
  Text,
  KeyWrapper,
  KeyItem,
  KeyTitle,
  KeyBlock,
  KeyText,
  Footer,
} from './elements';

const deps = {
  insights: state.challenge.visualisations.computedPersonalInsights,
  closeModalClicked: sequences`appContainer.closeModalClicked`,
};

export function StreakModal({
  insights,
  closeModalClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Modal onHide={() => closeModalClicked()} show>
      <CloseIconContainer>
        <CloseIcon icon={'icon-close'} onClick={() => closeModalClicked()} />
      </CloseIconContainer>
      <InnerWrapper>
        <StreakCircle
          size={'large'}
          icon={ICON.flame}
          iconColor={'#FF7043'}
          data={insights.streakInfo.data}
        />
        <Title>{t('challenge.StreakModal.day_streaks')}</Title>
        <Text>{t('challenge.StreakModal.log_activities')}</Text>
        <KeyWrapper>
          <KeyItem>
            <KeyTitle>{insights.streakInfo.daysLogged}</KeyTitle>
            <KeyBlock color={'#FF7043'} />
            <KeyText>{t('challenge.StreakModal.days_logged')}</KeyText>
          </KeyItem>
          <KeyItem>
            <KeyTitle>{insights.streakInfo.daysMissed}</KeyTitle>
            <KeyBlock color={'#90A4AE'} />
            <KeyText>{t('challenge.StreakModal.days_missed')}</KeyText>
          </KeyItem>
        </KeyWrapper>
      </InnerWrapper>
      <Footer
        onClick={() => closeModalClicked()}
        text={t('challenge.GMod08.close')}
      />
    </Modal>
  );
}

export default connect(deps, StreakModal);
